import Vue from 'vue'
Vue.prototype.$websiteGlobiz = 'https://globiz.com' // Puede ser globiz.com o globiz.es
Vue.prototype.$websiteFront = 'https://globiz.com' // es el sitio web front end, donde se copian las apis y un clon liviano de joomla para el manejo de logins

import App from './App.vue'

// import Vuex from 'vuex'
// Vue.use(Vuex)
import store from './store.js'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import Vuesax from 'vuesax'
// Vuesax styles
import './assets/css/vuesax.css'
// import 'vuesax/dist/vuesax.css'
Vue.use(Vuesax, {
  // options here
});
// Stepper styles retocados
// import './assets/css/HorizontalStepper.css'

Vue.prototype.$websiteGlobiz = 'https://globiz.com' // Puede ser globiz.com o globiz.es
Vue.prototype.$websiteFront = 'https://globiz.com' // es el sitio web front end, donde se copian las apis y un clon liviano de joomla para el manejo de logins

import BaseInput from '@/components/BaseInput'
import BaseCheck from '@/components/BaseCheck'
import BaseTextArea from '@/components/BaseTextArea'
import BaseSelect from '@/components/BaseSelect'
import BaseSelectTree from '@/components/BaseSelectTree'
import i18n from '@/i18n'
import router from '@/routes.js'

Vue.config.productionTip = false

Vue.component('BaseInput', BaseInput)
Vue.component('BaseCheck', BaseCheck)
Vue.component('BaseTextArea', BaseTextArea)
Vue.component('BaseSelect', BaseSelect)
Vue.component('BaseSelectTree', BaseSelectTree)

new Vue({
  // el: '#app-reg',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app-reg')
